import React from "react";

export default function FullSiteSearch({ searchTerm }) {
  return (
    <>
      <div className="full-search">
        <div className="full-search-text">
          <form method="get" role="search" action="/">
            <input type="hidden" value={searchTerm} name="s" />
            <input
              type="submit"
              value={`Can't find what you're looking for? Try a full site search for "${searchTerm}"`}
              className="submit font-size-m"
            />
          </form>
        </div>
      </div>
    </>
  );
}
